import request from "@/untils/request.js";
//登录方法
export function logIn(data) {
  return request({
    url: "/member/auth/login",
    method: "post",
    data,
  });
}
//注册
export function register(data) {
  return request({
    url: "/member/auth/register-mobile",
    method: "post",
    data,
  });
}
//发送短信验证码
export function getCode(data) {
  return request({
    url: "/member/auth/send-sms-code",
    method: "post",
    data,
  });
}
//修改密码
export function setPassword(data) {
  return request({
    url: "/member/user/reset-password",
    method: "post",
    data,
  });
}
